<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <app-sub-title text="Indicadores Por Usuario"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4" lg="3">
                <app-autocomplete
                    :items="administrativeUsers"
                    placeholder="Usuario"
                    v-model="selectedUser"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" md="3" lg="3">
                <b-form-select
                    :options="yearList"
                    v-model="selectedYear"
                    text-field="name"
                    value-field="id"
                    label="Año"
                    @change="validateForMonth"
                ></b-form-select>
            </b-col>
            <b-col cols="12" md="3" lg="3">
                <b-form-select
                    :options="monthList"
                    v-model="selectedMonth"
                    text-field="name"
                    value-field="id"
                    label="Mes"
                    :disabled="!selectedYear"
                ></b-form-select>
            </b-col>
            <b-col cols="12" md="2" lg="3">
                <b-btn variant="primary" @click="loadIndicators"><i class="fa fa-filter"></i></b-btn>
                <b-btn variant="secondary"><i class="fa fa-times"></i></b-btn>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-user-figures :selected-user="selectedUser" :year="selectedYear" :month="selectedMonth"></app-user-figures>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex';
import Autocomplete from '../../../../UI/Controls/AutocompleteV2/Autocomplete';
import reportingRepository from '../../../../../repositories/reporting.repository';
import UserFigures from './UserFigures/UserFigures';

export default {
    name: 'pqr_user_indicators',
    components: {
        appAutocomplete:  Autocomplete,
        appUserFigures:  UserFigures,
    },
    data: () => ({
        selectedUser: '',
        figures: '',
        selectedYear: '',
        selectedMonth: ''
    }),
    computed: {
        ...mapGetters(['administrativeUsers', 'years', 'months']),
        yearList() {
            return [{id: '', name: 'Seleccione un año'}, ...this.years];
        },
        monthList() {
            return [{id: '', name: 'Seleccione un mes'}, ...this.months];
        }
    },
    methods: {
        validateForMonth() {
            !!this.selectedYear && (this.selectedMonth = '');
        },
        loadIndicators() {
            this.$bus.$emit('pqr-user-figures.load');
            this.$bus.$emit('pqr-user-charts.load');
        }
    },
    created() {
        this.load('administrativeUsers');
        this.load('years');
        this.load('months');
    }
}
</script>